import { arDocHasFileName } from '../../../../shared';
import { useFilterByPrimaryDimensionArDocId } from '../../utils';
import { useAccountDocumentTransformApi } from '../api';

export const useAccountDocumentArDocHasFileName = () => {
  const filterPredicate = useFilterByPrimaryDimensionArDocId();
  const response = useAccountDocumentTransformApi({
    filterPredicate,
    transformFunction: arDocHasFileName,
  });
  return response;
};
